export enum CopyRequestOptions {
    Samples = 'Samples',
    SamplesWithContainers = 'SamplesWithContainers',
    SamplesWithAttachments = 'SamplesWithAttachments',
    SamplesWithContainersAndAttachments = 'SamplesWithContainersAndAttachments'
  }